import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS = '[QschecksModul] PostUpdateQsChecksMandantOptions laden';
export const POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_AUSFUEHREN = '[QschecksModul] PostUpdateQsChecksMandantOptions ausführen';
export const POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_ERFOLGREICH = '[QschecksModul] PostUpdateQsChecksMandantOptions laden erfolgreich';
export const POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_FEHLER = '[QschecksModul] PostUpdateQsChecksMandantOptions Ladefehler';
export const POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[QschecksModul] PostUpdateQsChecksMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostUpdateQsChecksMandantOptionsAction implements Action {
    readonly type = POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS;
        constructor(public qsChecksMandantOptions: api.QsChecksMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateQsChecksMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public qsChecksMandantOptions: api.QsChecksMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateQsChecksMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public qsChecksMandantOptions: api.QsChecksMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateQsChecksMandantOptionsFehlerAction implements Action {
    readonly type = POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public qsChecksMandantOptions: api.QsChecksMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateQsChecksMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksCommandUpdateQsChecksMandantOptionsActions =
    PostUpdateQsChecksMandantOptionsAction
    | PostUpdateQsChecksMandantOptionsAusfuehrenAction
    | PostUpdateQsChecksMandantOptionsErfolgreichAction
    | PostUpdateQsChecksMandantOptionsFehlerAction
    | PostUpdateQsChecksMandantOptionsNichtAusgefuehrtAction
    ;
